import { styled, alpha } from "@mui/material/styles";
import { Link } from "react-router-dom";

import Table from "@mui/material/Table";
import { TableCell, tableCellClasses } from "@mui/material";

export const TableWrapper = styled("div")({
  margin: "0px 100px 0px 40px",
  width: "100%",
  height: "100%"
});

export const LoaderWrapper = styled("span")({
  position: "absolute",
  top: "50%",
  left: "50%",
});

export const StyledTable = styled(Table)({
  minWidth: 750,
  borderCollapse: "separate",
  borderSpacing: "0 10px",
});

export const StyledLink = styled(Link)((props) => ({
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  textDecoration: "none",
  color: props?.theme?.palette?.grayScale?.gray1,
}));

export const statusColors = new Map([
  ["planning_evaluation", "#00A9E0"], 
  ["approved", "#78BE20"], 
  ["approved_with_restrictions", "#009775"], 
  ["process_evaluation", "#425563"],
  ["rejected", "#425563"],
  ["missing_information", "#E0004D"],
  ["request_extra_information", "#75010f"],
  ["technical_approved", "#00ff40"],
  ["technical_approved_with_restrictions", "#FFCD00"],
  ["technical_rejected", "#a35400"]
]);


export const getStatusStyle = (status: string) => {
  return {
    boxShadow: `inset 5px 0px 0px 0px ${statusColors.get(status)}`
  };
};